module.exports = {
	"id": "AF",
	"name": "Afghanistan",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.003182,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.019092,
			"9": 0.003182,
			"10": 0.009546,
			"11": 0.038184,
			"12": 0.006364,
			"13": null,
			"14": null,
			"15": 0.003182,
			"16": 0.019092,
			"17": 0.022274,
			"18": 0.006364,
			"19": 0.07955,
			"20": 0.01591,
			"21": 0.025456,
			"22": 0.006364,
			"23": 0.03182,
			"24": 0.028638,
			"25": 0.019092,
			"26": 0.01591,
			"27": 0.022274,
			"28": 0.041366,
			"29": 0.038184,
			"30": 0.038184,
			"31": 0.025456,
			"32": 0.012728,
			"33": 0.146372,
			"34": 0.06364,
			"35": 0.009546,
			"36": 0.01591,
			"37": 0.019092,
			"38": 0.028638,
			"39": 0.044548,
			"40": 0.022274,
			"41": 0.01591,
			"42": 0.03182,
			"43": 0.353202,
			"44": 0.054094,
			"45": 0.124098,
			"46": 0.098642,
			"47": 0.165464,
			"48": 0.050912,
			"49": 0.410478,
			"50": 0.06364,
			"51": 0.340474,
			"52": 0.28638,
			"53": 10.666064,
			"54": 2.771522,
			"55": 0.09546,
			"56": 0.01591,
			"57": null
		},
		"firefox": {
			"2": 0.006364,
			"3": 0.025456,
			"4": 0.028638,
			"5": null,
			"6": 0.003182,
			"7": 0.009546,
			"8": 0.009546,
			"9": 0.019092,
			"10": 0.022274,
			"11": 0.04773,
			"12": 0.025456,
			"13": 0.012728,
			"14": 0.03182,
			"15": 0.019092,
			"16": 0.006364,
			"17": 0.041366,
			"18": 0.041366,
			"19": 0.01591,
			"20": 0.009546,
			"21": 0.057276,
			"22": 0.022274,
			"23": 0.01591,
			"24": 0.073186,
			"25": 0.028638,
			"26": 0.009546,
			"27": 0.01591,
			"28": 0.012728,
			"29": 0.512302,
			"30": 0.044548,
			"31": 0.028638,
			"32": 0.01591,
			"33": 0.11137,
			"34": 0.050912,
			"35": 0.038184,
			"36": 0.044548,
			"37": 0.03182,
			"38": 0.117734,
			"39": 0.050912,
			"40": 0.054094,
			"41": 0.085914,
			"42": 0.066822,
			"43": 0.394568,
			"44": 0.146372,
			"45": 0.098642,
			"46": 0.162282,
			"47": 0.712768,
			"48": 0.712768,
			"49": 3.350646,
			"50": 0.295926,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.009546
		},
		"opera": {
			"9": null,
			"11": 0.006364,
			"12": null,
			"15": null,
			"16": null,
			"17": 0.006364,
			"18": null,
			"19": null,
			"20": 0.006364,
			"21": 0.006364,
			"22": 0.006364,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.009546,
			"30": 0.009546,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.028638,
			"35": 0.012728,
			"36": 0.022274,
			"37": 0.044548,
			"38": 0.019092,
			"39": 0.03182,
			"40": 0.486846,
			"41": 0.06364,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.006364,
			"12.1": 0.01591
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.009546,
			"6": 0.006364,
			"7": 0.022274,
			"8": 0.022274,
			"9": 0.054094,
			"10": 0.39775,
			"3.1": null,
			"3.2": null,
			"5.1": 0.006364,
			"6.1": 0.003182,
			"7.1": 0.006364,
			"9.1": 0.171828
		},
		"ios_saf": {
			"8": 0,
			"10": 3.92436359367,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.105757057868,
			"8.1-8.4": 0.195381683181,
			"9.0-9.2": 0.0932096103247,
			"9.3": 1.42204405495
		},
		"android": {
			"3": 0,
			"4": 0.188560863049,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0235701078811,
			"4.1": 0.680165970284,
			"4.2-4.3": 1.70041492571,
			"4.4": 3.89916927519,
			"4.4.3-4.4.4": 3.93284085788
		},
		"ie": {
			"6": 0.0478628293135,
			"7": 0.044671974026,
			"8": 0.379711779221,
			"9": 0.338230660482,
			"10": 0.287176975881,
			"11": 2.34208778108,
			"5.5": null
		},
		"op_mob": {
			"0": 0.435863641194,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0121073233665
		},
		"edge": {
			"12": 0.187738,
			"13": 0.171828,
			"14": 0.283198
		},
		"ie_mob": {
			"10": 0.0362986478873,
			"11": 0.147787352113
		},
		"bb": {
			"7": 0.006818,
			"10": null
		},
		"samsung": {
			"0": 4.547606
		},
		"and_uc": {
			"0": 7.002086
		},
		"op_mini": {
			"0": 5.87231503544
		},
		"and_chr": {
			"0": 34.24057
		},
		"and_ff": {
			"0": 0.06818
		}
	},
	"total": 98.274082
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/AF.json
 ** module id = 457
 ** module chunks = 0
 **/